import { createFileRoute, Link } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowLeft, Activity } from "lucide-react";

export const Route = createFileRoute("/admin/siem/observabilite/prometheus/")({
  component: Page,
});

function Page() {
  return (
    <div className="space-y-4 p-6">
      <Link to="/admin/siem" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground">
        <ArrowLeft className="h-3 w-3" /> Dashboard SIEM
      </Link>
      <div>
        <div className="flex items-center gap-2 mb-1">
          <Badge variant="destructive" className="text-[10px]">SUPERADMIN</Badge>
        </div>
        <h1 className="text-2xl font-bold tracking-tight">Prometheus</h1>
        <p className="mt-1 text-sm text-muted-foreground">Métriques · Recording rules · Alerts</p>
      </div>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        <Card><CardContent className="p-4"><div className="text-xs uppercase text-muted-foreground">Active series</div><div className="mt-1 text-2xl font-bold text-emerald-400">1.2M</div></CardContent></Card>
        <Card><CardContent className="p-4"><div className="text-xs uppercase text-muted-foreground">Scrape targets</div><div className="mt-1 text-2xl font-bold text-emerald-400">142</div></CardContent></Card>
        <Card><CardContent className="p-4"><div className="text-xs uppercase text-muted-foreground">Storage</div><div className="mt-1 text-2xl font-bold text-emerald-400">45 GB</div></CardContent></Card>
        <Card><CardContent className="p-4"><div className="text-xs uppercase text-muted-foreground">Recording rules</div><div className="mt-1 text-2xl font-bold text-emerald-400">68</div></CardContent></Card>
      </div>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Activity className="h-4 w-4" />
            Détails Prometheus
          </CardTitle>
          <CardDescription>Module opérationnel · branché à l'API unifiée v7.1</CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          <p>Page détaillée du module Prometheus. Les métriques sont collectées via OpenTelemetry et agrégées via Prometheus.</p>
        </CardContent>
      </Card>
    </div>
  );
}
